import { gql } from "@apollo/client";

export const DeleteRectangleBanner = gql`
mutation DeleteRectangleBanner($idStore: ID!) {
  deleteRectangleBanner(idStore: $idStore) {
    status
  }
}
`;
